// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__wzBhL","content":"Consent_content__2LuJ6","footer":"Consent_footer__k6AeY"};